import { Box, Typography, CircularProgress, Icon } from '@mui/material'
import PerfSortTable from 'components/reusable/table/PerfSortTable'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AdxPagination from 'components/custom/AdxPagination'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const PCompletedList = ({
  staffId,
  appraisalData,
  isLoading,
  hasRoles,
  currentPage,
  setCurrentPage,
  data,
}) => {
  const navigate = useNavigate()
  const location = useLocation()

  const formatCourseDate = (date) => {
    const dateObj = new Date(date + 'T00:00:00')
    return new Intl.DateTimeFormat('en-GB').format(dateObj)
  }

  const appraisalColumn = [
    {
      Header: 'Appraisal',
      accessor: 'appraisal_label',
      Cell: (props) => {
        const { value } = props

        return (
          <Typography sx={{ textAlign: 'left' }} textTransform="capitalize">
            {value}
          </Typography>
        )
      },
    },
    {
      Header: 'Start Date',
      accessor: 'start_date',
      Cell: (props) => {
        const { value } = props

        return <Typography sx={{ textAlign: 'left' }}>{formatCourseDate(value)}</Typography>
      },
    },
    {
      Header: 'End Date',
      accessor: 'due_date',
      Cell: (props) => {
        const { value } = props

        return <Typography sx={{ textAlign: 'left' }}>{formatCourseDate(value)}</Typography>
      },
    },
    {
      Header: 'My Score',
      accessor: 'total_score',
      Cell: (props) => {
        const { value } = props
        return (
          <Typography sx={{ textAlign: 'left' }}>{Math.round(value * 50) / 10 ?? '--'}</Typography>
        )
      },
    },
  ]

  const viewHandler = (item) => {
    navigate(`${location.pathname}/${item.appraisal_id}`, {
      state: {
        item,
        hasRoles,
        staffId,
        isActive: false,
      },
    })
  }

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography variant="h4" fontWeight="bold">
        {isLoading ? null : 'Completed'}
      </Typography>
      {isLoading ? (
        <Box height="70vh" display="flex" justifyContent="center" alignItems="center">
          <CircularProgress color="alternate" size={60} />
        </Box>
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          overflow="hidden"
          sx={{
            backgroundColor: 'white.main',
            border: 1,
            borderColor: 'gray-line.main',
            borderRadius: '4.5px',
            boxShadow: 'none',
            '& th.MuiTableCell-root': {
              padding: '6.5px 30px',
            },
            '& td.MuiTableCell-root': {
              padding: '0px',
            },
          }}
        >
          {appraisalData.length !== 0 ? (
            <>
              <PerfSortTable
                column={appraisalColumn}
                data={appraisalData}
                nav="View"
                onClick={viewHandler}
                sxHeader={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}
                sxNav={{ textDecoration: 'underline' }}
                sxCell
                sx={{ boxShadow: 0, borderRadius: 0 }}
              />
              <Box
                width="100%"
                display="flex"
                justifyContent="center"
                py={1}
                backgroundColor="white.main"
              >
                <AdxPagination
                  count={data?.meta?.last_page}
                  onChange={(event, page) => setCurrentPage(page)}
                />
              </Box>
            </>
          ) : (
            <AdxEmptyStateV2 icon={<Icon>track_changes</Icon>} title="No completed appraisal" />
          )}
        </Box>
      )}
    </Box>
  )
}

export default PCompletedList
